"use strict";
document.addEventListener("DOMContentLoaded", function() {
    var count = 0;
    var interval = setInterval(function() {
        console.log(count++);
        if (count === 10) clearInterval(interval);
    }, 1000);
});

//# sourceMappingURL=index.bf08aa83.js.map
